import { useState } from "react";
import { IPhoneCustomer } from "../models/IPhoneOrder";
import PhoneCustomerFormModal from "./PhoneCustomerFormModal";
import PhoneCustomerSearchBox from "./PhoneCustomerSearchBox";

interface Props {
  restaurantId: string;
}

/** Müşteri dizini: ara, kaydet, güncelle. Silme ucu yok. */
export default function PhoneCustomerDirectoryTab({ restaurantId }: Props) {
  const [selected, setSelected] = useState<IPhoneCustomer | null>(null);
  const [editing, setEditing] = useState<IPhoneCustomer | null>(null);
  const [creating, setCreating] = useState(false);
  const [prefill, setPrefill] = useState("");
  const [notice, setNotice] = useState("");
  // Kaydetmeden sonra arama kutusunu baştan kurmak için kullanılır.
  const [searchKey, setSearchKey] = useState(0);

  const handleSaved = (c: IPhoneCustomer, wasNew: boolean) => {
    setSelected(c);
    setNotice(wasNew ? `${c.firstName} ${c.lastName} dizine eklendi.` : `${c.firstName} ${c.lastName} güncellendi.`);
    setSearchKey((k) => k + 1);
  };

  return (
    <div className="pc-dir">
      <div className="pc-dir__head">
        <div>
          <h6 className="pc-dir__title"><i className="bi bi-journal-bookmark-fill me-2"></i>Müşteri Dizini</h6>
          <p className="pc-dir__sub">
            Telefonla sipariş alırken kullanılan, bu restorana özel adres defteri.
          </p>
        </div>
        <button className="dinein-btn dinein-btn--primary"
          onClick={() => { setPrefill(""); setNotice(""); setCreating(true); }}>
          <i className="bi bi-person-plus-fill me-1"></i>Yeni Müşteri
        </button>
      </div>

      {notice && (
        <div className="dinein-alert dinein-alert--success">
          <i className="bi bi-check-circle-fill"></i><span>{notice}</span>
          <button onClick={() => setNotice("")}><i className="bi bi-x-lg"></i></button>
        </div>
      )}

      <PhoneCustomerSearchBox
        key={searchKey}
        restaurantId={restaurantId}
        selectedId={selected?.id ?? null}
        onSelect={(c) => { setSelected(c); setNotice(""); }}
        onCreateNew={(q) => { setPrefill(q); setNotice(""); setCreating(true); }}
      />

      {selected && (
        <div className="pc-card">
          <div className="pc-card__head">
            <div>
              <div className="pc-card__name">{selected.firstName} {selected.lastName}</div>
              <div className="pc-card__phone"><i className="bi bi-telephone-fill me-1"></i>{selected.phoneNumber}</div>
            </div>
            <button className="dinein-btn dinein-btn--ghost" onClick={() => setEditing(selected)}>
              <i className="bi bi-pencil-square me-1"></i>Düzenle
            </button>
          </div>
          <dl className="pc-card__grid">
            <div><dt>İlçe</dt><dd>{selected.cityName}</dd></div>
            <div><dt>Bölge</dt><dd>{selected.townName}</dd></div>
            <div><dt>Sokak / Cadde</dt><dd>{selected.streetName}</dd></div>
            <div className="pc-card__wide"><dt>Adres Detayı</dt><dd>{selected.addressDetail}</dd></div>
          </dl>
          <div className="dinein-hint">
            <i className="bi bi-info-circle me-1"></i>
            Müşteri taşındıysa kaydı güncelleyin; geçmiş siparişlerin adresi değişmez.
          </div>
        </div>
      )}

      {creating && (
        <PhoneCustomerFormModal
          restaurantId={restaurantId}
          prefill={prefill}
          onClose={() => setCreating(false)}
          onSaved={(c) => handleSaved(c, true)}
        />
      )}

      {editing && (
        <PhoneCustomerFormModal
          restaurantId={restaurantId}
          initial={editing}
          onClose={() => setEditing(null)}
          onSaved={(c) => handleSaved(c, false)}
        />
      )}
    </div>
  );
}
